<!-- A new list is a dialog; the details of a list open in a side sheet,
its filter is changed on the list page. -->
<app-dialog
  [visible]="editorActive"
  (visibleChange)="!$event && closeEditor()"
  [closable]="true"
  [closeOnEscape]="false"
  [variant]="list ? 'sheet' : 'dialog'"
  [modal]="!list"
  [style]="list ? {} : { width: '560px' }"
  styleClass="list-editor-dialog"
>
  <form #form="ngForm" class="w3-container">
    <section class="w3-row header w3-margin-bottom">
      <div
        class="w3-twothird w3-bottombar w3-border-theme-secondary editor-title"
      >
        <i class="fa-solid fa-list fa-lg w3-large"></i>
        <span class="list-title text-bold w3-large upper-case">{{
          (list === null ? 'mylists.label.newlist' : 'mylists.label.updatelist')
            | translate
        }}</span>
      </div>
      <div class="w3-third">
        @if (!list) {
          <div class="w3-right">
            <button
              type="button"
              class="round-button"
              (click)="isSolid.star = !isSolid.star"
            >
              <i
                [ngClass]="
                  (isSolid.star ? 'fa-solid' : 'fa-regular') + ' fa-star'
                "
              ></i>
            </button>
            <button
              type="button"
              class="round-button"
              (click)="isSolid.bell = !isSolid.bell"
            >
              <i
                [ngClass]="
                  isSolid.bell ? 'fa-solid fa-bell' : 'fa-regular fa-bell-slash'
                "
              ></i>
            </button>
          </div>
        }
      </div>
    </section>
    @if (editorActive) {
      <section class="w3-row name w3-margin-bottom">
        <div class="w3-twothird">
          <label
            for="list-editor-name"
            class="w3-medium text-bold required"
            translate
          >
            common.label.name
          </label>
          <span class="validated-input" [class.invalid]="isInvalid('name')">
            <input
              type="text"
              required
              class="app-input editor-input"
              id="list-editor-name"
              name="name"
              [(ngModel)]="name"
              (focus)="focusedField = 'name'"
              (blur)="focusedField = null"
            />
            @if (isInvalid('name')) {
              <span class="invalid-icon">!</span>
            }
          </span>
          @if (isInvalid('name') && focusedField === 'name') {
            <div class="validation-message">Required</div>
          }
        </div>
        <div class="w3-third"></div>
      </section>
      <section class="w3-row description w3-margin-bottom">
        <div class="w3-twothird">
          <label
            for="list-editor-description"
            class="w3-medium text-bold required"
            translate
          >
            common.label.description
          </label>
          <span
            class="validated-input"
            [class.invalid]="isInvalid('description')"
          >
            <input
              type="text"
              required
              class="app-input editor-input"
              id="list-editor-description"
              name="description"
              [(ngModel)]="description"
              (focus)="focusedField = 'description'"
              (blur)="focusedField = null"
            />
            @if (isInvalid('description')) {
              <span class="invalid-icon">!</span>
            }
          </span>
          @if (isInvalid('description') && focusedField === 'description') {
            <div class="validation-message">Required</div>
          }
        </div>
        <div class="w3-third"></div>
      </section>
    }
    @if (!list) {
      <section class="w3-row w3-section">
        <div class="w3-rest">
          <button
            matButton
            type="button"
            class="w3-small dynamic-toggle"
            (click)="isDynamicList = !isDynamicList"
          >
            <i
              class="fa-regular w3-text-theme-secondary"
              [ngClass]="isDynamicList ? 'fa-square-check' : 'fa-square'"
            ></i>
            <span>{{ 'mylists.action.createDynamic' | translate }}</span>
          </button>
        </div>
      </section>
    }
    @if (isDynamicList && list) {
      <p class="definition-hint">
        {{ 'mylists.label.filterOnPage' | translate }}
      </p>
    }
    @if (isDynamicList && !list && initialFilter?.length) {
      <p class="filter-summary">
        <strong>{{ 'mylists.label.savedFilter' | translate }}:</strong>
        {{ summary }}
      </p>
    } @else if (isDynamicList && !list) {
      <p class="definition-hint">
        {{ 'mylists.label.filterNext' | translate }}
      </p>
    }
  </form>
  <ng-template appDialogFooter>
    <button
      matButton="filled"
      type="button"
      class="save-button"
      (click)="saveList()"
    >
      {{
        (definesFilterNext ? 'mylists.action.setFilter' : 'common.action.save')
          | translate
      }}
    </button>
  </ng-template>
</app-dialog>
